import React, { useEffect, useState } from 'react'
import NavigationBar from '../components/NavigationBar'
import { StatusBar } from 'expo-status-bar'
import { useRecoilState, useRecoilValue } from 'recoil'
import { userState, locationState, showNavState } from '../state/atoms'
import { collection, doc, getDoc, getDocs, onSnapshot } from 'firebase/firestore'
import { auth, db } from '../firebase'
import * as Location from 'expo-location'
import * as Permissions from 'expo-permissions'

const MainContainer = () => {
    // Global State
    const [userData, setUserData] = useRecoilState(userState)
    const [location, setLocation] = useRecoilState(locationState)
    const [permissions, setPermissions] = useState(false)
    const showNav = useRecoilValue(showNavState)

    const getUserDataOnLogin = async () => {
        const user = auth.currentUser
        const docRef = doc(db, 'users', user.uid)
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
            setUserData(docSnap.data())
        } else {
            alert('Something has gone wrong, please try again later')
        }
    }

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, 'users', auth.currentUser.uid), (docSnap) => {
            setUserData(docSnap.data())
        })
        return () => {
            unsubscribe()
        }
    }, [])

    const getLocationAsync = async () => {
        let { status } = await Permissions.askAsync(Permissions.LOCATION_FOREGROUND)
        if (status !== 'granted') {
            setLocation('Permission to access location was denied')
        } else {
            setPermissions(true)
        }

        let location = await Location.getCurrentPositionAsync({})
        setLocation(location)
    }

    useEffect(() => {
        getUserDataOnLogin()
        getLocationAsync()
    }, [])
    return (
        <>
            <StatusBar style="dark" />
            {showNav && <NavigationBar />}
        </>
    )
}

export default MainContainer
